import React, { useState, useEffect } from 'react';
import './quad.scss';
import brownTruck from '../../images/brown-truck.jpg';
import liftedTruck from '../../images/lifted-truck.jpg';
import blackTruck from '../../images/black-truck.jpg';
import twoTrucks from '../../images/two-trucks.jpg';
import brownTruckLarge from '../../images/brown-truck-large.jpg';
import liftedTruckLarge from '../../images/lifted-truck-large.jpg';
import blackTruckLarge from '../../images/black-truck-large.jpg';
import twoTrucksLarge from '../../images/two-trucks-large.jpg';

const Quad = () => {
    const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 992);

    // Update state on window resize
    useEffect(() => {
        const handleResize = () => {
            setIsLargeScreen(window.innerWidth >= 992);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Select images based on screen size
    const images = isLargeScreen
        ? [brownTruckLarge, liftedTruckLarge, blackTruckLarge, twoTrucksLarge]
        : [brownTruck, liftedTruck, blackTruck, twoTrucks];

    return (
        <div className="quad-grid">
            {images.map((image, index) => (
                <div key={index} className="quad-cell">
                    <img src={image} alt={`Quad ${index}`} />
                </div>
            ))}
        </div>
    );
};

export default Quad;